import { region } from '#shared/constants/firebase'

const SHARE_IMAGE_VERSION = '2'

/**
 * Composable for sharing functionality
 */
export function useSharing() {
    const config = useRuntimeConfig()

    /**
     * Gets the API base URL (works on both SSR and client)
     */
    function getApiBaseUrl(): string {
        const projectId = config.public.FIREBASE_PROJECT_ID
        const isEmulator = config.public.FIREBASE_USE_EMULATOR === 'true'

        return isEmulator
            ? `http://localhost:5001/${projectId}/${region}/api`
            : `https://${region}-${projectId}.cloudfunctions.net/api`
    }

    /**
     * Gets a URL for sharing content with an image
     */
    function getSharingUrl(type: string, image: string): string {
        if (type && image) {
            const encodedImageUrl = encodeURIComponent(image.replace('%2F', '_-_'))

            return `${getApiBaseUrl()}/share/${type}?url=${encodedImageUrl}&v=${SHARE_IMAGE_VERSION}`
        }

        return 'https://growni.sk/images/growni-miesto-pre-tvoj-rast-mentoring-workshopy-dobrovolnictvo-staze-joby.jpg'
    }

    /**
     * Converts an object to URL parameters for sharing
     */
    function objectToGetParams(object: any) {
        return (
            '?' +
            Object.keys(object)
                .filter((key) => !!object[key])
                .map((key) => `${key}=${encodeURIComponent(object[key])}`)
                .join('&')
        )
    }

    return {
        getSharingUrl,
        objectToGetParams
    }
}
